/**
 * Zweck: Beschreibt class NewsEntryTag und ihren Daten- oder Funktionsvertrag.
 */
/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/models/news-entry-tag.ts.
 */
export class NewsEntryTag {
  id: number;
  name: string;
  roles: string[];
  visible: boolean;
}
